import { searchData, getAPI } from "./helpers";

const itemsContainer = document.querySelector('.cardsContainer');
const buttonRefreshData = document.querySelector(`.refreshButton`);
const loadingAnim = document.querySelector(`.loading`);
const searchForm = document.querySelector(`.search-form`)
const select = document.getElementById("select");

var firstParamSelections = ["any", "black", "white", "yellow", "orange", "red", "purple", "magenta", "green", "teal", "blue"];

const getData = async function () {
  loadingAnim.style.display = 'block';
  searchData.isFetching = true
  await getAPI()
  // console.log(searchData.searchResults)
  searchData.isFetching = false;
  if (results.length === 0) {
    searchData.hasMoreItems = false
  } else {
    searchData.searchPage++
  }
  loadingAnim.style.display = 'none';
  // console.log(results.length)
  return results
}


const firstShowItems = async function () {
  await getData();
  const itemsList = searchData.searchResults;
  itemsList.forEach(item => {
    // console.log(item)
    // const html = getHTML(item)
    // itemsContainer.insertAdjacentHTML('afterbegin', html)  
    const article = document.createElement('div')    
    article.innerHTML = getHTML(item)
    itemsContainer.appendChild(article)
    const modalTrigger = article.querySelector('img[data-trigger-lightbox]')
    modalTrigger.addEventListener("click", triggerLightBox(article))
  })
  
  searchData.searchResults = []
}


const getHTML = function (entry) {
  const entryId = entry.id;
  const entryTitle = entry.description;
  const entrySourceLink = entry.link;
  const entryRawImage = entry.raw;
  const entryFullImage = entry.full;
  const entryRegularImage = entry.regular;
  const entrySmallURL = entry.small;
  const entryThumblURL = entry.thumb;
  return `
  
   
  <div id="target-lightbox-${entryId}" >
  <div class="container">
  <div id="image-modal" class="modal">
    <div class="modal-background"></div>
    <div class="modal-content">
     <div class="modal-card">   
     <div class="modal-card-image">
     <figure class="image is-4by3">
     target="_blank" >Link</a><img class='modal-image' src=${entryRegularImage} alt="Placeholder image">
     </figure>
   </div>
    <section class="modal-card-body">    
    <div class="buttons">
    <a href=${entrySourceLink}  target="_blank" > <button class="button is-primary mx-1"> Source page </button> </a>
    <a href=${entryRawImage}  target="_blank" ><button class="button  mx-1"> Raw </button> </a></a>
    <a href=${entryFullImage}  target="_blank" ><button class="button mx-1"> Full </button> </a></a>
    <a href=${entryRegularImage}  target="_blank" ><button class="button  mx-1"> Regular </button> </a></a>
    <a href=${entrySmallURL}  target="_blank" ><button class="button  mx-1"> Small </button> </a></a>
    <a href=${entryThumblURL}  target="_blank" download><button class="button mx-1"> Thumbnail </button> </a></a>
    </div>    
    </section>   
  </div>
    </div>
    <button id="image-modal-close" class="modal-close"></button>
  </div> 
</div>
</div>


  
  <img class="gallery-img target-buttons-${entryId}" style="cursor: pointer;" data-trigger-lightbox="target-lightbox-${entryId}" src=${entrySmallURL} alt="Image"> 
  

     
`
}

const init = function () {

  for (var i = 0; i < firstParamSelections.length; i++) {
    var opt = firstParamSelections[i];
    var el = document.createElement("option");
    el.textContent = opt;
    el.value = opt;
    select.appendChild(el);
  }



  searchForm.addEventListener('submit', function (e) {
    e.preventDefault()
    itemsContainer.innerHTML = ''
    searchData.searchTerm = document.querySelector('.search-text-field').value;
    searchData.searchPage = 1;
    searchData.isFetching = true;
    searchData.hasMoreItems = true;
    secondParam = document.querySelector('.first-param-field').value;

    if (secondParam === 'any') {
      searchData.secondParam = ''
    } else {
      searchData.secondParam = `&color=${secondParam}`
    }

    // console.log(searchData.secondParam)
    // console.log(typeof searchData.secondParam)     
    // console.log(searchData)
    firstShowItems()
  })


  window.addEventListener('scroll', () => {
    if (searchData.isFetching || !searchData.hasMoreItems) return
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 5) {
      // console.log('scrolled')
      firstShowItems()
    }
  })



// --<unused functio to wait for element to be created and do an action>

  // function waitForElm(selector) {
  //   return new Promise(resolve => {
  //     if (document.querySelector(selector)) {
  //       return resolve(document.querySelector(selector));
  //     }

  //     const observer = new MutationObserver(mutations => {
  //       if (document.querySelector(selector)) {
  //         observer.disconnect();
  //         resolve(document.querySelector(selector));
  //       }
  //     });

  //     observer.observe(document.body, {
  //       childList: true,
  //       subtree: true
  //     });
  //   });
  // }

 
}

function triggerLightBox(targetElem) {     
      
  return function (event) {
    // // bail out if lightbox is not initialized
    // if (!('GLightbox' in targetElem)) {
    //   console.log(`GLightbox does not exist in #${targetElem.id}`);
    //   return;
    // }        
    // console.log(targetElem)        
    const modalDlg = targetElem.querySelector('#image-modal');
    modalDlg.classList.add('is-active')       
    
    const imageModalCloseBtn = targetElem.querySelector('#image-modal-close')
    imageModalCloseBtn.addEventListener('click', function () {
      modalDlg.classList.remove('is-active');
    });
    // console.log(modalDlg)
    // console.log(imageModalCloseBtn)

    // targetElem.GLightbox.open();
  }
}


init()
